__turbopack_context__.v({
  "fade-in": "PopularSearches-module-scss-module__tiMFFW__fade-in",
  "item": "PopularSearches-module-scss-module__tiMFFW__item",
  "itemButton": "PopularSearches-module-scss-module__tiMFFW__itemButton",
  "label": "PopularSearches-module-scss-module__tiMFFW__label",
  "list": "PopularSearches-module-scss-module__tiMFFW__list",
  "root": "PopularSearches-module-scss-module__tiMFFW__root",
});
